
import p17 from '@/assets/img/p-17.jpg'
import p18 from '@/assets/img/p-18.jpg'
import p19 from '@/assets/img/p-19.jpg'
import p20 from '@/assets/img/p-20.jpg'
import p21 from '@/assets/img/p-21.jpg'
import p22 from '@/assets/img/p-22.jpg'

import work1 from '@/assets/img/svg/work-1.svg'
import work2 from '@/assets/img/svg/work-2.svg'
import work3 from '@/assets/img/svg/work-3.svg'
export const workData = [
    {
        icon:'fa-solid fa-unlock-keyhole text-primary',
        id:1,
        image:work1,
        title:'استكشف المعارض ',
        desc:'تصفح أحدث المعارض والفعاليات بسهولة عبر دليل شامل ومحدّث باستمرار.',
        bg:'f-light-success'
    },
    {
        icon:'fa-brands fa-twitter text-primary',
        id:2,
        image:work2,
        title:'تواصل مباشرة ',
        desc:'احصل على تفاصيل العارضين، واحجز مواعيدك، وتفاعل مع منظمي الفعاليات بسهولة.',
        bg:'f-light-warning'
    },
    {
        icon:'fa-solid fa-layer-group text-primary',
        id:3,
        image:work3,
        title:'شارك وكن حاضرًا ',
        desc:'احجز تذاكرك، خطط زيارتك، وكن جزءًا من أبرز الأحداث والمعارض في السوق.',
        bg:'f-light-purple'
    },
]

export const workDataEn = [
    {
        icon:'fa-solid fa-unlock-keyhole text-primary',
        id:1,
        image:work1,
        title:'Explore Exhibitions',
        desc:'Browse the latest exhibitions and events effortlessly through a comprehensive and regularly updated guide',
        bg:'f-light-success'
    },
    {
        icon:'fa-brands fa-twitter text-primary',
        id:2,
        image:work2,
        title:'Connect Directly',
        desc:'Access exhibitor details, schedule appointments, and engage with event organizers effortlessly',
        bg:'f-light-warning'
    },
    {
        icon:'fa-solid fa-layer-group text-primary',
        id:3,
        image:work3,
        title:'Participate & Be Present',
        desc:'Book your tickets, plan your visit, and be part of the most prominent events and exhibitions in the market',
        bg:'f-light-purple'
    },
]

export const footerLink1 = [
    {
        title:'About Us',
        link:'/about-us'
    },
    {
        title:'FAQs Page',
        link:'/faq'
    },
    {
        title:'Checkout',
        link:'/checkout'
    },
    {
        title:'Contact',
        link:'/contact'
    },
    {
        title:'Blog',
        link:'/blog'
    },
]

export const blogData = [
    {
        id:1,
        image:p17,
        date:'تواصل معنا ',
        title:'اكتشف الفعاليات',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:2,
        image:p18,
        date:'تواصل معنا ',
        title:'توسّع في الأسواق',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:3,
        image:p19,
        date:'تواصل معنا ',
        title:'تواصل مع العالم',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:4,
        image:p20,
        date:'تواصل معنا ',
        title:'اكتشف الفعاليات',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:5,
        image:p21,
        date:'تواصل معنا ',
        title:'توسّع في الأسواق',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:6,
        image:p22,
        date:'تواصل معنا ',
        title:'تواصل مع العالم',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
]

export const aboutData = [
    {
        icon:'fa-solid fa-unlock-keyhole text-primary',
        title:'استكشف المعارض ',
        desc:'تصفح أحدث المعارض والفعاليات بسهولة عبر دليل شامل ومحدّث باستمرار.'
    },
    {
        icon:'fa-brands fa-twitter text-primary',
        title:'تواصل مباشرة ',
        desc:'احصل على تفاصيل العارضين، واحجز مواعيدك، وتفاعل مع منظمي الفعاليات بسهولة.'
    },
    {
        icon:'fa-solid fa-layer-group text-primary',
        title:'شارك وكن حاضرًا ',
        desc:'احجز تذاكرك، خطط زيارتك، وكن جزءًا من أبرز الأحداث والمعارض في السوق.'
    },
]
export const faqData = [
    {
        id:1,
        title:'ما هو رُقُم؟',
        desc:`رُقُم هو منصة إلكترونية متخصصة في عرض أحدث المعارض والفعاليات التجارية في سوريا، مما يساعد المستخدمين في البحث، التواصل، والمشاركة بسهولة.`
    },
    {
        id:2,
        title:'هل يتطلب استخدام الموقع تسجيل حساب؟',
        desc:`لا، يمكنك تصفح المعارض دون تسجيل، لكن لإنشاء قائمة مفضلة أو التواصل مع العارضين، ستحتاج إلى حساب مجاني.`
    },
    {
        id:3,
        title:'كيف يمكنني البحث عن معرض معين؟',
        desc:`يمكنك استخدام محرك البحث المتقدم في الموقع، حيث يمكنك تصفية النتائج حسب المجال، التاريخ، أو الموقع.`
    },
    {
        id:4,
        title:'هل يوفر الموقع إمكانية التسجيل في المعارض؟',
        desc:`في الوقت الحالي لا لكن معلومات للتواصل المباشر مع منظمي المعارض لحجز مكانك.`
    },
    {
        id:5,
        title:'كيف أستطيع إضافة معرض جديد إلى الموقع؟',
        desc:`إذا كنت من منظمي الفعاليات، يمكنك إرسال تفاصيل المعرض من خلال نموذج الإضافة المتاح في الموقع، وسيتولى فريقنا مراجعته ونشره.`
    },
    {
        id:6,
        title:'هل يمكنني التواصل مع العارضين؟',
        desc:`نعم، يتيح الموقع معلومات الاتصال الخاصة بالعارضين، كما يمكنك إرسال استفسارات مباشرة من خلال المنصة.`
    },
    {
        id:7,
        title:'هل استخدام الموقع مجاني؟',
        desc:`نعم، تصفح المعارض والفعاليات مجاني تمامًا، مع وجود بعض الخدمات الإضافية التي قد تتطلب اشتراكً في وقت لاحق.`
    },
    {
        id:8,
        title:'كيف يمكنني تلقي إشعارات حول المعارض الجديدة؟',
        desc:`يمكنك الاشتراك في النشرة البريدية أو القيام في الإشتراك في قناة الموقع على الواتس أو تلغرام للحصول على إشعارات المعارض الجديدة.`
    },
    {
        id:9,
        title:'هل يوفر الموقع معلومات حول المعارض الدولية؟',
        desc:`حاليًا، يركز رُقُم على المعارض في سوريا، لكننا نعمل على توسيع قاعدة البيانات لتشمل فعاليات إقليمية قريبًا.`
    },
    {
        id:10,
        title: 'كيف يمكنني التواصل مع فريق الدعم؟',
        desc:`يمكنك التواصل معنا عبر نموذج الاتصال في الموقع، أو مراسلتنا عبر البريد الإلكتروني، وسنكون سعداء بمساعدتك في أي استفسار.`
    },

]
export const faqDataEn = [
    {
        id:1,
        title:'What is Ruqm?',
        desc:`Ruqm is an online platform dedicated to showcasing the latest trade exhibitions and events in Syria, helping users search, connect, and participate effortlessly.`
    },
    {
        id:2,
        title:'Do I need to create an account to use the platform?',
        desc:`No, you can browse exhibitions without registering. However, to create a favorites list or contact exhibitors, you’ll need a free account.`
    },
    {
        id:3,
        title:'How can I search for a specific exhibition?',
        desc:`You can use the platform’s advanced search feature to filter results by industry, date, or location.`
    },
    {
        id:4,
        title:'Can I register for exhibitions through Ruqm?',
        desc:`Currently, Ruqm does not offer direct registration, but we provide organizer contact details so you can book your spot easily.`
    },
    {
        id:5,
        title:'How can I add a new exhibition to the platform?',
        desc:`If you’re an event organizer, you can submit exhibition details via the submission form on our website. Our team will review and publish it accordingly.`
    },
    {
        id:6,
        title:'Can I connect with exhibitors?',
        desc:`Yes, Ruqm provides exhibitor contact details, and you can also send inquiries directly through the platform.`
    },
    {
        id:7,
        title:'Is the platform free to use?',
        desc:`Yes, browsing exhibitions and events is completely free, with some additional services that may require a subscription in the future.`
    },
    {
        id:8,
        title:'How can I receive notifications about new exhibitions?',
        desc:`You can subscribe to our newsletter or join our WhatsApp and Telegram channels to stay updated`
    },
    {
        id:9,
        title:'Does Ruqm provide information about international exhibitions?',
        desc:`Currently, Ruqm focuses on exhibitions in Syria, but we are working on expanding our database to include regional events soon.`
    },
    {
        id:10,
        title: 'How can I contact the support team?',
        desc:`You can reach us via the contact form on our website or email us directly. Our team is happy to assist you with any inquiries.`
    },

]
export const faq2En = [
    {
        id:1,
         title:'Can I register for exhibitions through Ruqm?',
        desc:`Currently, Ruqm does not offer direct registration, but we provide organizer contact details so you can book your spot easily.`
    },
    {
        id:2,
        title:'How can I add a new exhibition to the platform?',
        desc:`If you’re an event organizer, you can submit exhibition details via the submission form on our website. Our team will review and publish it accordingly.`
    },
    {
        id:3,
        title:'Can I connect with exhibitors?',
        desc:`Yes, Ruqm provides exhibitor contact details, and you can also send inquiries directly through the platform.`
    },
]
export const faq2 = [
    {
        id:1,
        title:'هل يوفر الموقع إمكانية التسجيل في المعارض؟',
        desc:`في الوقت الحالي لا لكن معلومات للتواصل المباشر مع منظمي المعارض لحجز مكانك.`
    },
    {
        id:2,
        title:'كيف أستطيع إضافة معرض جديد إلى الموقع؟',
        desc:`إذا كنت من منظمي الفعاليات، يمكنك إرسال تفاصيل المعرض من خلال نموذج الإضافة المتاح في الموقع، وسيتولى فريقنا مراجعته ونشره.`
    },
    {
        id:3,
        title:'هل يمكنني التواصل مع العارضين؟',
        desc:`نعم، يتيح الموقع معلومات الاتصال الخاصة بالعارضين، كما يمكنك إرسال استفسارات مباشرة من خلال المنصة.`
    },
]
export const faq3 = [
    {
        id:1,
        title:'هل استخدام الموقع مجاني؟',
        desc:`نعم، تصفح المعارض والفعاليات مجاني تمامًا، مع وجود بعض الخدمات الإضافية التي قد تتطلب اشتراكً في وقت لاحق.`
    },
    {
        id:2,
        title:'كيف يمكنني تلقي إشعارات حول المعارض الجديدة؟',
        desc:`يمكنك الاشتراك في النشرة البريدية أو القيام في الإشتراك في قناة الموقع على الواتس أو تلغرام للحصول على إشعارات المعارض الجديدة.`
    },
    {
        id:3,
        title:'هل يوفر الموقع معلومات حول المعارض الدولية؟',
        desc:`حاليًا، يركز رُقُم على المعارض في سوريا، لكننا نعمل على توسيع قاعدة البيانات لتشمل فعاليات إقليمية قريبًا.`
    },
]

export const termEn = [
` 
<h2>1. Acceptance of Terms</h2>
<p>By accessing Ruqm Platform (“the Platform”, “we”, “our”), you agree to comply with these Terms & Conditions. If you do not agree, you must stop using the Platform and its services.</p>
<h2>2. Scope of Service</h2>
<p>Ruqm Platform provides the following services:</p>
<ul>
<li>Listing local and international exhibitions</li>
<li>Displaying exhibitor and company profiles</li>
<li>Enabling communication between visitors and exhibitors</li>
<li>Offering a digital archive of events</li>
<li>Allowing organizers to submit exhibitions according to platform guidelines</li>
<li>The Platform reserves the right to update or modify services at any time.</li>
</ul>
<h2>3. User Accounts</h2>
<p>When creating an account, users must provide accurate and complete information. They are fully responsible for:</p>
<ul>
<li>Maintaining account confidentiality</li>
<li>All activities performed through their account</li>
<li>Updating information if changes occur</li>
<li>The Platform may suspend or delete accounts that violate policies.</li>
</ul>
<h2>4. Exhibition Submission and Content</h2>
<p>By submitting exhibition details or uploading any content, organizers agree that:</p>
<ul>
<li>All provided information is accurate and lawful</li>
<li>They own the rights to use any uploaded images, logos, or materials</li>
<li>They grant Ruqm Platform the right to display this content</li>
<li>Content must comply with platform guidelines</li>
<li>The Platform may edit or remove any content deemed inappropriate.</li>
</ul>
<h2>5. Intellectual Property</h2>
<p>All content on Ruqm Platform including:</p>
<ul>
<li>Text, graphics, designs</li>
<li>Platform logo and brand</li>
<li>Databases</li>
<li>Source code</li>
</ul>
<p>is the property of the Platform or its licensors. Copying or redistribution without permission is strictly prohibited.</p>
<h2>6. Platform Usage</h2>
<p>Users must not use the Platform for unlawful or harmful purposes, including:</p>
<ul>
<li>Unauthorized data collection</li>
<li>Attempting to hack or disrupt the Platform</li>
<li>Publishing misleading or inappropriate content</li>
<li>Exploiting system vulnerabilities</li>
<li>Violation may result in legal action.</li>
</ul>
<h2>7. Limitation of Liability</h2>
<p>Ruqm Platform is not responsible for:</p>
<ul>
<li>Incorrect information provided by exhibitors or organizers</li>
<li>Any transactions made outside the Platform</li>
<li>Technical issues beyond its control</li>
<li>Misuse of information by users</li>
</ul>
<p>All services are provided “as is” without warranties.</p>
<h2>8. External Links</h2>
<p>The Platform may include links to third-party websites. Ruqum is not responsible for the content or policies of these sites.</p>
<h2>9. Changes to Terms</h2>
<p>Ruqm Platform may update these Terms at any time. Continued use of the Platform constitutes acceptance of the updated terms.</p>
<h2>10. Contact Us</h2>
<p>
For questions related to these Terms & Conditions, please contact:
info@ruqm.me
</p>
`
]

export const termAr = [
`
<h2>1. قبول الشروط</h2>
<p>باستخدامكم لمنصة رُقُم ("المنصة"، "نحن"، "لدينا")، فإنكم توافقون على الالتزام التام بهذه الشروط والأحكام. وفي حال عدم الموافقة، يرجى الامتناع عن استخدام المنصة أو أي من خدماتها.</p>
<h2>2. نطاق الخدمة</h2>
<p>توفر منصة رُقُم الخدمات التالية:</p>
<ul>
<li>عرض معلومات المعارض المحلية والدولية.</li>
<li>عرض بيانات الشركات المشاركة في المعارض.</li>
<li>تمكين التواصل بين الشركات والزوار عبر المنصة.</li>
<li>توفير أرشيف رقمي للفعاليات والمعارض.</li>
<li>إتاحة إضافة معارض جديدة عبر الشركات المنظمة وفق ضوابط المنصة.</li>
<li>تحتفظ المنصة بحق تعديل أو تحديث الخدمات دون إشعار مسبق.</li>
</ul>
<h2>3. حسابات المستخدمين</h2>
<p>عند إنشاء حساب، يجب على المستخدم تقديم معلومات صحيحة وكاملة، ويتحمّل المسؤولية الكاملة عن:</p>
<ul>
<li>الحفاظ على سرية بيانات الدخول</li>
<li>جميع الأنشطة التي تتم من خلال حسابه</li>
<li>تحديث بياناته عند حدوث أي تغيير</li>
<li>يحق للمنصة إيقاف أو حذف أي حساب يخالف الشروط أو يقدّم معلومات مضللة.</li>
</ul>
<h2>4. إضافة المعارض والمحتوى</h2>
<p>عند قيام المنظم بإضافة معرض أو تحميل معلومات عبر المنصة، فإنه يقرّ بما يلي:</p>
<ul>
<li>دقّة وصحة المعلومات المقدمة</li>
<li>امتلاكه كامل الحقوق لتزويد البيانات والصور والشعارات</li>
<li>منحه منصة رُقُم حق عرض هذه البيانات ضمن خدماتها</li>
<li>التزامه بسياسات المحتوى وعدم نشر أي مواد مخالفة أو مضللة</li>
<li>يحق للمنصة تعديل أو إزالة أي محتوى لا يتوافق مع معاييرها.</li>
</ul>
<h2>5. حقوق الملكية الفكرية</h2>
<p>جميع المحتويات الموجودة في منصة رُقُم بما في ذلك:</p>
<ul>
<li>النصوص</li>
<li>التصاميم</li>
<li>الشعار والعلامة التجارية</li>
<li>قواعد البيانات</li>
<li>الأكواد البرمجية</li>
</ul>
<p>هي ملك للمنصة أو الجهات المالكة لها، ويُمنع نسخها أو إعادة نشرها دون إذن خطّي.</p>
<h2>6. استخدام المنصة</h2>
<p>يُحظر استخدام المنصة لأي أغراض غير قانونية، بما في ذلك:</p>
<ul>
<li>جمع بيانات الشركات أو المستخدمين لأغراض تجارية غير مصرح بها</li>
<li>محاولة اختراق أو تعطيل المنصة</li>
<li>نشر معلومات مضللة أو محتوى غير لائق</li>
<li>التحايل على الأنظمة أو استغلال الثغرات التقنية</li>
<li>تحتفظ المنصة بحق اتخاذ الإجراءات القانونية عند مخالفة ذلك.</li>
</ul>
<h2>7. حدود المسؤولية</h2>
<p>لا تتحمل منصة رُقُم أي مسؤولية عن:</p>
<ul>
<li>أخطاء المعلومات المقدمة من الشركات أو المنظمين</li>
<li>أي تعاملات تجارية تتم خارج المنصة</li>
<li>أي أعطال تقنية خارجة عن سيطرتها</li>
<li>استخدام المستخدمين للمعلومات المعروضة بطرق غير صحيحة</li>
<li>تُقدَّم خدمات المنصة "كما هي" بدون أي ضمانات صريحة أو ضمنية.</li>
</ul>
<h2>8. الروابط الخارجية</h2>
<p>قد تتضمن المنصة روابط لمواقع خارجية، ولا تتحمل رُقُم أي مسؤولية عن محتوى أو سياسات تلك المواقع.</p>
<h2>9. التعديلات على الشروط</h2>
<p>تحتفظ منصة رُقُم بحق تعديل هذه الشروط في أي وقت. ويُعد استمراركم في استخدام المنصة بعد التعديلات موافقة ضمنية عليها.</p>
<h2>10. التواصل</h2>
<p>
للاستفسارات المتعلقة بهذه الشروط، يرجى التواصل عبر البريد:
info@ruqm.me
</p>
`
]

export const privacyEn = [
`<h2>1. Introduction</h2>
<p>Ruqm Platform (“we”, “our”, “the Platform”) is committed to protecting your privacy and personal data. This Privacy Policy outlines how we collect, use, store, and process the information you provide when using our website or services.</p>

<p>By accessing Ruqm Platform, you agree to the terms of this Privacy Policy.</p>

<h2>2. Information We Collect</h2>
<p><strong>A. Information You Provide Directly</strong></p>
<p>This may include:</p>
<ul>
<li>Full name</li>
<li>Email address</li>
<li>Phone number</li>
<li>Company or exhibitor information</li>
<li>Exhibition details submitted for listing</li>
<li>Information shared through forms or communication tools</li>
</ul>

<h2>B. Information Collected Automatically</h2>
<p>When you browse the Platform, we may collect:</p>
<ul>
<li>IP address</li>
<li>Browser type and device type</li>
<li>Access times and visited pages</li>
<li>Cookies and tracking information</li>
</ul>

<h2>C. Exhibitor and Event Data</h2>
<p>When adding exhibitions or company profiles, we may collect:</p>
<ul>
<li>Company name</li>
<li>Country and city</li>
<li>Contact information</li>
<li>Business description</li>
<li>Images and promotional content</li>
</ul>
<h2>3. How We Use the Information</h2>
<p>We may use personal and organizational data for the following purposes:</p>
<ul>
<li>Providing and managing Ruqm services</li>
<li>Displaying exhibitions and company profiles</li>
<li>Facilitating communication between visitors and exhibitors</li>
<li>Improving user experience and enhancing platform performance</li>
<li>Sending updates related to exhibitions and events</li>
<li>Maintaining an ongoing digital archive of events</li>
<li>Compliance with legal obligations</li>
</ul>
<h2>4. Data Sharing</h2>
<p>Your data may be shared with:</p>
<ul>
<li>Exhibition organizers for communication purposes</li>
<li>Technical service providers and partners</li>
<li>Government authorities when legally required</li>
</ul>
<p>We do not sell or share your data for unauthorized commercial use.</p>
<h2>5. Data Protection</h2>
<p>We implement technical and administrative measures to protect your data from:</p>
<ul>
<li>Unauthorized access</li>
<li>Misuse, alteration, or loss</li>
<li>Security breaches or unlawful processing</li>
</ul>
<p>However, no internet-based system can guarantee absolute protection.</p>
<h2>6. Your Rights</h2>
<p>You may request:</p>
<ul>
<li>Access to your personal data</li>
<li>Correction of inaccurate information</li>
<li>Deletion of your data when legally applicable</li>
<li>Withdrawal of consent for data processing</li>
<li>Opting out of marketing communications</li>
</ul>
<p>For inquiries, contact:
info@ruqm.me</p>
<h2>7. Cookies Policy</h2>
<p>Ruqm Platform uses cookies to enhance user experience. You may disable cookies from your browser settings, but doing so may affect certain features of the website.
</p>
<h2>8. Changes to This Privacy Policy</h2>
<p>The Platform reserves the right to update this Policy at any time. Updates will be displayed on this page with a revision date.</p>
<h2>9. Contact Information</h2>
<p>
For any questions regarding this Privacy Policy, please contact us at:
info@ruqm.me
</p>
`
]

export const privacyAr=[
`
<h2>1.مقدمة</h2>
<p>ترحّب بكم منصة رُقُم ("المنصة"، "نحن"، "لدينا")، وتؤكد التزامها الكامل بحماية خصوصيتكم وبياناتكم الشخصية. توضح هذه السياسة كيفية جمع بياناتكم، وكيفية استخدامها، والحقوق التي تتمتعون بها عند استخدام المنصة أو أي من خدماتها.
</p>
<p>باستخدامكم لمنصة رُقُم، فإنكم توافقون على أحكام سياسة الخصوصية هذه.
</p>
<h2>2. البيانات التي نقوم بجمعها</h2>
<p>أ. البيانات التي تقدمونها مباشرة
</p>
<p>نجمع بعض البيانات عند قيامكم باستخدام خدمات المنصة، مثل:
</p>
<ul>
<li>الاسم الكامل</li>
<li>البريد الإلكتروني</li>
<li>رقم الهاتف</li>
<li>بيانات الشركة أو الجهة المشاركة</li>
<li>معلومات المعرض أو الفعالية المراد إضافتها</li>
<li>أي معلومات يتم إدخالها عبر نماذج التواصل أو التسجيل</li>
</ul>
<h2>ب. البيانات التي يتم جمعها تلقائيًا</h2>
<p>عند استخدام المنصة، قد نُسجّل تلقائيًا معلومات مثل:</p>
<ul>
<li>عنوان الـ IP</li>
<li>نوع المتصفح والجهاز</li>
<li>صفحات الدخول والخروج</li>
<li>وقت وتاريخ الزيارة</li>
<li>ملفات تعريف الارتباط (Cookies)</li>
</ul>
<h2>ج. بيانات الشركات المشاركة</h2>
<p>عند إدراج معرض أو ملف شركة، قد يتم جمع البيانات التالية:</p>
<ul>
<li>اسم الشركة</li>
<li>التصنيف</li>
<li>الدولة والمدينة</li>
<li>بيانات التواصل</li>
<li>وصف النشاط والخدمات</li>
<li>الصور والمواد التعريفية</li>
</ul>
<h2>3. كيفية استخدام البيانات</h2>
<p>نستخدم بياناتكم للأغراض التالية:</p>
<ul>
<li>إدارة وتقديم خدمات منصة رُقُم</li>
<li>تسهيل عملية عرض المعارض والشركات</li>
<li>تمكين التواصل بين الزوار والشركات المشاركة</li>
<li>تحسين تجربة المستخدم وتطوير خدمات المنصة</li>
<li>إرسال إشعارات أو تحديثات متعلقة بالمعارض</li>
<li>الأرشفة الرقمية للفعاليات والشركات</li>
<li>الامتثال للقوانين واللوائح المعمول بها</li>
</ul>
<h2>4. مشاركة البيانات</h2>
<p>قد تتم مشاركة بياناتكم مع:</p>
<ul>
<li>الشركات المنظمة للمعارض عند رغبتكم بالتواصل معها</li>
<li>الجهات الشريكة أو مقدمي الخدمات التقنيين</li>
<li>الجهات الرسمية في حال طلبها قانونيًا</li>
</ul>
<p>تتعهد منصة رُقُم بعدم بيع بياناتكم أو مشاركتها لأغراض تجارية غير مصرح بها.</p>
<h2>5. حماية البيانات</h2>
<p>نقوم باتخاذ مجموعة من الإجراءات التقنية والتنظيمية لحماية بياناتكم من:</p>
<ul>
<li>الوصول غير المصرح به</li>
<li>التعديل أو التغيير</li>
<li>الفقدان أو التلف</li>
<li>الاستخدام غير المشروع</li>
</ul>
<p>مع ذلك، لا يمكن ضمان حماية كاملة عبر الإنترنت، ويقر المستخدم بهذا.</p>
<h2>6. حقوق المستخدمين</h2>
<p>يحق لكم:</p>
<ul>
<li>طلب الوصول إلى بياناتكم الشخصية</li>
<li>طلب تصحيح البيانات غير الدقيقة</li>
<li>طلب حذف البيانات في الحالات التي يسمح بها القانون</li>
<li>سحب الموافقة على معالجة البيانات عندما يكون ذلك ممكنًا</li>
<li>طلب عدم استخدام بياناتكم لأغراض تسويقية</li>
</ul>
<p>
للاستفسارات أو الطلبات، يمكنكم التواصل عبر البريد الرسمي:
info@ruqm.me
</p>
<h2>7. ملفات تعريف الارتباط (Cookies)</h2>
<p>تستخدم المنصة ملفات تعريف الارتباط لتحسين تجربة الاستخدام. يمكنكم تعطيلها من إعدادات المتصفح، وقد يؤثر ذلك على بعض ميزات الموقع.</p>
<h2>8. التعديلات على سياسة الخصوصية</h2>
<p>تحتفظ المنصة بحق تحديث هذه السياسة في أي وقت. سيتم نشر التعديلات على هذه الصفحة مع تحديث تاريخ آخر تعديل.</p>
<h2>9. التواصل</h2>
<p>
لمزيد من المعلومات حول سياسة الخصوصية، يرجى التواصل معنا عبر:
info@ruqm.me
</p>
`
]




















